import '@septima/septima-search/src/css/defaultView.css';
import '@septima/septima-search/lib/jquery.better-autocomplete.js';
import '@septima/septima-search/lib/jquery.caret.1.02.js';
import Controller from '@septima/septima-search/src/js/Controller';
import DefaultView from '@septima/septima-search/src/js/defaultview/DefaultView';
import DawaSearcher from '@septima/septima-search/src/js/searchers/DawaSearcher';
import ClientSearcher from '@septima/septima-search/src/js/searchers/ClientSearcher';
import GeoDkApi from '@/api/GeoDanmark';

export function setupSearch (targetElement, selectHandler, errorHandler, kommunekode, geodktoken) {
  let controller = new Controller(
    [],
    {
      onError: errorHandler,
      blankBehavior: 'none', // search
    });

  let dawaSearcher = new DawaSearcher({
    kommunekode: kommunekode,
    showOneStreet: true,
    onSelect: selectHandler,
    minimumShowCount: 0,
  });
  controller.addSearcher({ searcher: dawaSearcher });

  const resultTransform = geodkobjekt => {
    const result = { status: 'ok', hits: 0, results: [] };
    if (geodkobjekt.data.relationships.objekttype.data.id) {
      result.results.push({
        title: geodkobjekt.data.id,
        geometry: geodkobjekt.data.attributes.geometri,
        geodkobjekt: geodkobjekt.data,
      });
    }
    return result;
  };
  const objektSearcher = new ClientSearcher({
    singular: 'GeoDanmark Objekt',
    plural: 'GeoDanmark Objekter',
    isAsync: true,
    onSelect: selectHandler,
    provider: {
      query (query) {
        if (query === '' || query.match(/^\d+$/) === null || query.length !== 10) {
          return new Promise((resolve) => {
            resolve({ status: 'ok', hits: 0, results: [] });
          });
        } else {
          const adapterOptions = { slettet: true };
          return GeoDkApi.getGeoDkObjektByIdRaw(query, adapterOptions, geodktoken)
            .then(resultTransform)
            .catch(error => {
              console.log(error);
              return { status: 'ok', hits: 0, results: [] };
            });
        }
      },
    },
  });
  controller.addSearcher({ title: 'Objekter', searcher: objektSearcher });

  let view = new DefaultView(
    {
      input: targetElement,
      controller: controller,
      mouseover: true,
      limit: 10,
    });

  return view;
}
